export default __webpack_public_path__ + "static/do-icon-color-image-bf1106316526581c421acbe54ba9a113.png";